// `/admin/rates` (`spec/17-frontend.md` §8.2, `spec/tasks/WEB-77.md`). Sem `useMode`:
// taxa default não tem sandbox, a rota é de admin e não manda `X-Mode`.
//
// O drawer de edição abre por `?edit=<id da versão>`, `files_allowed` não tem rota
// `$id`, então o estado mora no `search` (mesma solução da WEB-70). Deep link desenha a
// lista embaixo e o drawer por cima; `catch(undefined)` engole lixo na URL.

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { RatesScreen } from '../features/admin-rates/rates-screen.tsx';

const searchSchema = z.object({
  edit: z.string().min(1).optional().catch(undefined),
});

function AdminRates() {
  const { edit } = Route.useSearch();
  const navigate = useNavigate();

  return (
    <RatesScreen
      editId={edit}
      onEdit={(id) => {
        void navigate({ to: '/admin/rates', search: id === undefined ? {} : { edit: id } });
      }}
    />
  );
}

export const Route = createFileRoute('/admin/rates/')({
  validateSearch: searchSchema,
  component: AdminRates,
});
